import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const ReverseIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8 11L12 7M12 7L16 11M12 7V15C12 16.1046 12.8954 17 14 17H16"
        stroke={fillColor || '#111112'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { ReverseIcon };
